
const NOISE_PATTERNS = [
  'ResizeObserver',
  'Script error',
  'NetworkError',
  'Failed to fetch',
  'Load failed',
  'Amplitude',
  'chrome-extension',
  'moz-extension',
  'Non-Error promise rejection',
  'AbortError',
]

function isNoise(message: string): boolean {
  return NOISE_PATTERNS.some((p) => message.includes(p))
}

export const setupGlobalErrorHandlers = () => {
  window.addEventListener('error', (e) => {
    if (isNoise(e.message)) {
      e.preventDefault()
      e.stopPropagation()
    }
  })

  // Capturer les vraies promesses non catchées dans Sentry
  window.addEventListener('unhandledrejection', (e) => {
    const msg =
      e.reason instanceof Error
        ? e.reason.message
        : typeof e.reason === 'string'
          ? e.reason
          : String(e.reason ?? '')

    if (isNoise(msg)) {
      e.preventDefault()
      return
    }

    if (import.meta.env.PROD) {
      import('@sentry/react')
        .then((Sentry) => {
          Sentry.captureException(
            e.reason instanceof Error ? e.reason : new Error(`Unhandled rejection: ${msg}`),
            { tags: { type: 'unhandledrejection' } }
          )
        })
        .catch(() => {})
    }
  })
}
